<template>
  <div>
    <el-table :data="data" border style="width: 100%" size="mini">
      <el-table-column prop="frequency" label="频率" :width="70">
      </el-table-column>
      <el-table-column prop="signal_strength" label="信号强度" :width="80">
      </el-table-column>
      <el-table-column prop="upload_time" label="上传时间" :width="160">
      </el-table-column>
      <el-table-column label="录音文件" :width="100">
        <template slot-scope="scope">
          <el-button v-if="scope.row.radio_file_path" type="text" @click="$playAudio(scope.row.radio_file_path,scope.row.frequency,scope.row.upload_time)">点击播放</el-button>
          <template v-else>无文件</template>
        </template>
      </el-table-column>
      <el-table-column prop="recognition" label="音频识别">
      </el-table-column>
      <el-table-column prop="result_type_name" label="判别结果" :width="85">
      </el-table-column>
    </el-table>
    <Pagination :totalCountOrURL="data.length" :params="null" @change="handlePageChange"></Pagination>
  </div>
</template>

<script>
  import Pagination from "@/components/PageNations/Pagination";
  export default {
    props: ["task_record_id"],
    components: {
      Pagination
    },
    mounted() {
      this.getData();
    },
    watch: {
      task_record_id() {
        this.getData();
      }
    },
    data() {
      return {
        data: [],
        subdata: [],
        page: 1,
        size: 10
      };
    },
    methods: {
      handlePageChange(params) {
        this.page = params.page;
        this.size = params.size;
        this.subdata = this.data.slice(this.size * (this.page - 1), this.size * this.page);
      },
      getData() {
        if (this.task_record_id) {
          console.log(this.task_record_id)
          this.$getJSON("/task/s_taskResult", {
            task_record_id: this.task_record_id
          }).then(res => {
            this.data = res.data;
            this.subdata = this.data.slice(this.size * (this.page - 1), this.size * this.page);
          });
        }
      }
    }
  };

</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/Tables/TaskResult.vue